import React from "react";
import { Col, Row } from "react-bootstrap";
import { number, string } from "prop-types";

const ColoredRawScoreScale = (props) => {
  const { score, testId, styleClass = "" } = props;

  const getLabelInfo = () => {
    switch (testId) {
      case 30:
        return {
          labelMap: {
            "Not Proficient": { count: 13, color: "orange" },
            Proficient: { count: 4, color: "green-striped" },
            "Highly Proficient": { count: 3, color: "dark-green" },
          },
          labelOrder: ["Not Proficient", "Proficient", "Highly Proficient"],
          cellCount: 20,
        };
      case 49:
      default:
        return {
          labelMap: {
            "Not Proficient": { count: 16, color: "orange" },
            Proficient: { count: 5, color: "green-striped" },
            "Highly Proficient": { count: 4, color: "dark-green" },
          },
          labelOrder: ["Not Proficient", "Proficient", "Highly Proficient"],
          cellCount: 25,
        };
    }
  };

  const getCellsInfo = () => {
    const { labelOrder, labelMap, cellCount } = getLabelInfo();
    const cellWidth = 100 / cellCount;
    let cellIdx = 0;
    const cells = [];
    const brackets = [];
    labelOrder.forEach((label) => {
      const { count, color } = labelMap[label];
      brackets.push(
        <div key={label} style={{ width: `${cellWidth * count}%` }}>
          <div className="scale-bracket">&nbsp;</div>
          <p className="scale-label">{label}</p>
        </div>
      );

      [...Array(count).keys()].forEach((i) => {
        cellIdx += 1;
        cells.push(
          <div
            key={`${i}_${label}`}
            style={{ width: `${cellWidth}%`, height: "20px" }}
            className={`scale-cell scale-cell-${color}`}
          >
            {score === cellIdx ? (
              <div className="colored-raw-score-bubble">
                <div>{score}</div>
              </div>
            ) : null}
          </div>
        );
      });
    });

    return { cells, brackets };
  };

  const { cells = null, brackets = null } = getCellsInfo();

  return (
    <Col>
      {styleClass === "candidate-summary" && (
        <Row>
          <h5
            className="sr-h5 w-100 text-center"
            style={{ margin: "-18px 0 15px 0" }}
          >
            Raw Score
          </h5>
        </Row>
      )}
      <Row>
        <Col>
          <Row>{cells}</Row>
          <Row>{brackets}</Row>
        </Col>
      </Row>
    </Col>
  );
};

ColoredRawScoreScale.propTypes = {
  score: number,
  testId: number,
  styleClass: string,
};

export default ColoredRawScoreScale;
